import { Router, RouteData, NavigationRoute } from 'shared-utils';
import { getYearRouteParam } from 'utils/yearStore';
import CampaignScreen from './CampaignScreen';

export const CampaignNavigation = (): NavigationRoute => new NavigationRoute(
    CampaignScreen.key,
    [getYearRouteParam()]
);

const router = new Router();

router
    .add(new RouteData({
        key: CampaignScreen.key,
        path: '',
        component: CampaignScreen,
        exact: true,
        metadata: {
            authRequired: true,
            rolesAllowed: ['administrator', 'supervisor', 'writer']
        }
    }));

export default router;